module.exports = __webpack_public_path__ + "static/media/robe.5b61ecba.svg";